import { em } from 'polished'
import styled from 'styled-components'

import DynamicImage from 'components/DynamicImage'
import SectionWrapper from 'components/SectionWrapper'

import highlightMd from './assets/highlight-md.svg'
import highlightXs from './assets/highlight-xs.svg'

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: ${em(281)};

  ${p => p.theme.mq.upMd} {
    height: ${em(380)};
  }
`

export const DynamicImageStyled = styled(DynamicImage)`
  width: ${em(300)};
  position: absolute;
  left: 0;
  right: 0;
  margin: ${em(50)} auto;
  transform: translateX(${em(-30)});
  height: auto;

  ${p => p.theme.mq.upMd} {
    width: ${em(294)};
    bottom: ${em(-40)};
    right: ${em(-140)};
    margin: auto;
  }

  ${p => p.theme.mq.upLg} {
    width: ${em(346)};
    bottom: ${em(-70)};
  }
`

export const LineImg = styled.img`
  position: absolute;
  display: none;

  ${p => p.theme.mq.upLg} {
    display: block;
    width: ${em(346)};
    left: ${em(-351)};
    right: 0;
    bottom: ${em(-100)};
    margin: auto;
  }
`

export const SectionWrapperStyled = styled(SectionWrapper)`
  background-color: ${p => p.theme.colors.black};
`

export const Highlight = styled.div`
  background: url(${highlightXs}) 0 0 no-repeat;
  width: ${em(300)};
  height: ${em(181)};
  position: absolute;
  left: 0;
  right: 0;
  margin: ${em(40)} auto;
  transform: translateX(${em(-30)});

  ${p => p.theme.mq.upMd} {
    background: url(${highlightMd}) 0 0 no-repeat;
    width: ${em(40)};
    height: ${em(112)};
    left: 50%;
    right: auto;
    bottom: 0;
    transform: translate(-200%, -20%);
    margin: auto;
  }

  ${p => p.theme.mq.upLg} {
    display: none;
  }
`
